export enum DeliveryTypeEnum {
  EXPRESS = 'EXPRESS',
  NATIONAL = 'NATIONAL',
  ENVIALOYA = 'ENVIALOYA',
  EXPOUTZONE = 'EXPRESS FUERA DE ZONA',
  SUBSCRIPTION = 'SUBSCRIPTION',
  SCANANDGO = 'SCANANDGO',
  MARKETPLACE = 'PROVIDER',
}
